/**
 * Markdown, in a .js file so it can simply be imported.
 *
 * A plain `.md` would be handled by webpack's catch-all asset rule and import as a *URL* rather
 * than as text, which would mean fetching the doc at runtime — a request that fails exactly when
 * the app is most likely to be offline, on stage. The backticks are the whole cost of avoiding it.
 *
 * See src/utils/markdown.js for the syntax that is actually read.
 */
const smartScroll = `
# Smart Scroll

Ordinary auto scroll moves at **one constant speed**, which can only ever be right for the average
of a song. Smart Scroll gives every part its own speed instead: it works out how long each part
lasts, measures how tall it is on screen, and matches the two.

It reads the song's BPM and time signature, then each part's length — a repeat count, a chord bars
chart, bar lines in an instrumental, or an estimate off the lyrics. The control on the plugin row
becomes a **pace percentage**: 100% is the written tempo, and changing it stretches the whole song
together rather than one part at a time.

## Getting the most out of it

- **Set the song's BPM and time signature.** Everything else is worked out from them, so this is
  the one setting Smart Scroll can't do without.
- **Set a repeat count** on any part you play more than once — otherwise it is timed as a single
  pass and races through it.
- **Give a part a chart.** A chart states its own length exactly, instead of the part being counted
  a chord at a time or estimated off its lines — so it is the best thing any part can carry. The
  **Chord Bars** button in the lyrics toolbar builds one for you: written into the words of an
  instrumental as bar lines, "| Dm | Em C | B |", and kept beside the words of a sung part. A
  charted part is played at the length its chart gives it, and pace leaves it alone.
- **Time a part that never quite fits** with the **Repeat Timer**, next to it in the same toolbar.
  A timed part is used exactly as measured, and pace leaves it alone.
`;

export default smartScroll;
